/**
 * @fileoverview GET handler for the "/engagement/segments/:segment_id/download_selector" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsSegmentIdDownloadSelector } from "./constants";
import type { EngagementSegmentsSegmentIdDownloadSelectorResult } from "./types";
import type { EngagementSegmentsSegmentIdDownloadSelectorParams } from "./types";

export const getEngagementSegmentsSegmentIdDownloadSelector = reactQueryFetcherAdapter(
  engagementSegmentsSegmentIdDownloadSelector,
  (
    signal: AbortSignal,
    { appGroupId, segmentId, calculateStatsParams, type }: EngagementSegmentsSegmentIdDownloadSelectorParams
  ): Promise<EngagementSegmentsSegmentIdDownloadSelectorResult> => {
    return fetch(
      `/engagement/segments/${segmentId}/download_selector`,
      "POST",
      {
        app_group_id: appGroupId,
        segment_id: segmentId,
        calculate_stats_params: calculateStatsParams,
        type: type,
      },
      { signal }
    );
  }
);
